import {GalleryItem} from "../Gallery";

export const gallery2023Items: GalleryItem[] = [
"/static/Gallery/2023/1.jpg",
"/static/Gallery/2023/2.jpg",
"/static/Gallery/2023/3.jpg",
"/static/Gallery/2023/4.jpg",
"/static/Gallery/2023/5.jpg",
"/static/Gallery/2023/6.jpg",
"/static/Gallery/2023/7.jpg",
"/static/Gallery/2023/8.jpg",
"/static/Gallery/2023/9.jpg",
"/static/Gallery/2023/10.jpg",
"/static/Gallery/2023/11.jpg",
"/static/Gallery/2023/12.jpg",
"/static/Gallery/2023/13.jpg",
"/static/Gallery/2023/14.jpg",
"/static/Gallery/2023/15.jpg",
"/static/Gallery/2023/16.jpg",
"/static/Gallery/2023/17.jpg",
"/static/Gallery/2023/18.jpg",
"/static/Gallery/2023/19.jpg",
"/static/Gallery/2023/20.jpg",
"/static/Gallery/2023/21.jpg",
"/static/Gallery/2023/22.jpg",
"/static/Gallery/2023/23.jpg",
"/static/Gallery/2023/24.jpg",
"/static/Gallery/2023/25.jpg",
"/static/Gallery/2023/26.jpg",
"/static/Gallery/2023/27.jpg",
"/static/Gallery/2023/28.jpg",
"/static/Gallery/2023/29.jpg",
"/static/Gallery/2023/30.jpg",
];
